import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { fifthStepLabelMap, firstStepLabelMap, fourthStepLabelMap, secondStepLabelMap, thirdStepLabelMap } from './step-label-maps';
import { GoalsFormComponent } from './goals-form/goals-form.component';
import { ModalSizeEnum } from 'src/types';
import { SupervisionService } from 'src/services/supervision.service';
import { error } from 'console';
import { ToastrImplService } from 'src/services/toastr.service';
import { ErrorType, manageError } from 'src/app/utils/warningMessage';

interface CompetencyRowDto {
   rating: number | null;
   comment: string;
}

interface CaseManagerAssessmentDto {
   id: number | null;
   legalRegulationsKnowledge: CompetencyRowDto;
   targetGroupKnowledge: CompetencyRowDto;
   professionalKnowledgeApplication: CompetencyRowDto;
   caseManagementProcessKnowledge: CompetencyRowDto;
   professionalProceduresKnowledge: CompetencyRowDto;
   caseDocumentation: CompetencyRowDto;
   independentCaseHandling: CompetencyRowDto;
   teamFormationAssessment: CompetencyRowDto;

   activeListening: CompetencyRowDto;
   counselingAndSupportSkills: CompetencyRowDto;
   interviewingSkills: CompetencyRowDto;
   assertivenessAndBoundarySettingSkills: CompetencyRowDto;
   writtenCorrespondenceSkills: CompetencyRowDto;
   negotiationSkills: CompetencyRowDto;
   teamwork: CompetencyRowDto;
   expressionCulture: CompetencyRowDto;
   conflictAndDifficultSituationManagement: CompetencyRowDto;

   workingHoursAndDisciplineRespect: CompetencyRowDto;
   timeManagement: CompetencyRowDto;
   timelyAndEffectiveInterventionPlanning: CompetencyRowDto;
   initiative: CompetencyRowDto;
   flexibility: CompetencyRowDto;
   decisiveness: CompetencyRowDto;

   respectForDiversity: CompetencyRowDto;
   userEmpowerment: CompetencyRowDto;
   rightsAdvocacy: CompetencyRowDto;
   maintainingProfessionalBoundaries: CompetencyRowDto;

   opennessToSupervision: CompetencyRowDto;
   criticalSelfAssessment: CompetencyRowDto;
   learningAndProfessionalDevelopment: CompetencyRowDto;

   caseManagerStrengths: string;
   areasForImprovement: string;
   goals: Array<any>;
   workerId?: number;
}

@Component({
   selector: 'app-competency-questionnaire-new',
   templateUrl: './competency-questionnaire-new.component.html',
   styleUrls: ['./competency-questionnaire-new.component.scss'],
})
export class CompetencyQuestionnaireNewComponent implements OnInit {
   firstStepForm!: FormGroup;
   secondStepForm: FormGroup;
   thirdStepForm: FormGroup;
   fourthStepForm: FormGroup;
   fifthStepForm: FormGroup;
   sixthStepForm: FormGroup;
   displayedColumns: string[] = ['goal', 'activities', 'timeframe', 'responsiblePerson', 'actions'];
   goals: Array<any> = new Array<any>();

   ratings: number[] = [1, 2, 3, 4, 5];
   id: number | null = null;
   firstStepLabelMap = firstStepLabelMap;
   secondStepLabelMap = secondStepLabelMap;
   thirdStepLabelMap = thirdStepLabelMap;
   fourthStepLabelMap = fourthStepLabelMap;
   fifthStepLabelMap = fifthStepLabelMap;
   btnDisabled = false;
   constructor(
      @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<CompetencyQuestionnaireNewComponent>,
      private fb: FormBuilder,
      private cdr: ChangeDetectorRef,
      public dialog: MatDialog,
      private supervisionService: SupervisionService,
      private toastr: ToastrImplService
   ) {
      this.firstStepForm = this.fb.group({
         legalRegulationsKnowledge: this.createRow('legalRegulationsKnowledge'),
         targetGroupKnowledge: this.createRow('targetGroupKnowledge'),
         professionalKnowledgeApplication: this.createRow('professionalKnowledgeApplication'),
         caseManagementProcessKnowledge: this.createRow('caseManagementProcessKnowledge'),
         professionalProceduresKnowledge: this.createRow('professionalProceduresKnowledge'),
         caseDocumentation: this.createRow('caseDocumentation'),
         independentCaseHandling: this.createRow('independentCaseHandling'),
         teamFormationAssessment: this.createRow('teamFormationAssessment'),
      });

      this.secondStepForm = this.fb.group({
         activeListening: this.createRow('activeListening'),
         counselingAndSupportSkills: this.createRow('counselingAndSupportSkills'),
         interviewingSkills: this.createRow('interviewingSkills'),
         assertivenessAndBoundarySettingSkills: this.createRow('assertivenessAndBoundarySettingSkills'),
         writtenCorrespondenceSkills: this.createRow('writtenCorrespondenceSkills'),
         negotiationSkills: this.createRow('negotiationSkills'),
         teamwork: this.createRow('teamwork'),
         expressionCulture: this.createRow('expressionCulture'),
         conflictAndDifficultSituationManagement: this.createRow('conflictAndDifficultSituationManagement'),
      });
      this.thirdStepForm = this.fb.group({
         workingHoursAndDisciplineRespect: this.createRow('workingHoursAndDisciplineRespect'),
         timeManagement: this.createRow('timeManagement'),
         timelyAndEffectiveInterventionPlanning: this.createRow('timelyAndEffectiveInterventionPlanning'),
         initiative: this.createRow('initiative'),
         flexibility: this.createRow('flexibility'),
         decisiveness: this.createRow('decisiveness'),
      });
      this.fourthStepForm = this.fb.group({
         respectForDiversity: this.createRow('respectForDiversity'),
         userEmpowerment: this.createRow('userEmpowerment'),
         rightsAdvocacy: this.createRow('rightsAdvocacy'),
         maintainingProfessionalBoundaries: this.createRow('maintainingProfessionalBoundaries'),
      });
      this.fifthStepForm = this.fb.group({
         opennessToSupervision: this.createRow('opennessToSupervision'),
         criticalSelfAssessment: this.createRow('criticalSelfAssessment'),
         learningAndProfessionalDevelopment: this.createRow('learningAndProfessionalDevelopment'),
      });

      this.sixthStepForm = this.fb.group({
         caseManagerStrengths: [''],
         areasForImprovement: [''],
      });
      this.supervisionService.getIfExistInWorkCaseManagerAssessment(this.data.workerId).subscribe(response => {
         this.populateFormsFromDto(response);
      });
   }

   ngOnInit(): void {}

   private createRow(rowType: string): FormGroup {
      return this.fb.group({
         rating: [null],
         comment: [''],
         type: [rowType],
      });
   }

   closeDialog(): void {
      this.dialogRef.close({ event: 'Cancel' });
   }

   addGoal(): void {
      const dialogRef = this.dialog.open(GoalsFormComponent, {
         disableClose: false,
         panelClass: 'overlay-panel',
         width: ModalSizeEnum.DEFAULT,
      });

      dialogRef.afterClosed().subscribe(data => {
         if (data.event === 'Create') {
            this.goals = [...this.goals, data.data]; // promena reference
            this.cdr.detectChanges();
         }
      });
   }

   editGoal(goal: any, index: number): void {
      const dialogRef = this.dialog.open(GoalsFormComponent, {
         disableClose: false,
         panelClass: 'overlay-panel',
         width: ModalSizeEnum.DEFAULT,
         data: goal,
      });

      dialogRef.afterClosed().subscribe(data => {
         if (data.event === 'Edit') {
            this.goals[index] = data.data;
            this.goals = [...this.goals]; // promena reference
            this.cdr.detectChanges();
         }
      });
   }

   deleteGoal(index: number): void {
      this.goals.splice(index, 1);
      this.goals = [...this.goals]; // promena reference
      this.cdr.detectChanges();
   }

   private mapFormGroup(form: FormGroup): Record<string, CompetencyRowDto> {
      const result: Record<string, CompetencyRowDto> = {};

      Object.keys(form.controls).forEach(key => {
         const control = form.get(key) as FormGroup;
         result[key] = {
            rating: control.get('rating')?.value,
            comment: control.get('comment')?.value,
         };
      });

      return result;
   }

   buildAssessmentDto(): CaseManagerAssessmentDto {
      return {
         ...this.mapFormGroup(this.firstStepForm),
         ...this.mapFormGroup(this.secondStepForm),
         ...this.mapFormGroup(this.thirdStepForm),
         ...this.mapFormGroup(this.fourthStepForm),
         ...this.mapFormGroup(this.fifthStepForm),

         caseManagerStrengths: this.sixthStepForm.get('caseManagerStrengths')?.value,
         areasForImprovement: this.sixthStepForm.get('areasForImprovement')?.value,
         goals: this.goals,
         workerId: this.data.workerId,
         id: this.id,
      } as CaseManagerAssessmentDto;
   }
   generateReport(): void {
      this.btnDisabled = true;
      this.supervisionService.generateCaseManagerAssessmentReport(this.buildAssessmentDto()).subscribe(
         response => {
            this.btnDisabled = false;
            this.dialogRef.close({ event: 'Save' });
         },
         error => {
            manageError(this.toastr, ErrorType.SAVE_DATA);
            this.btnDisabled = false;
         }
      );
   }

   saveAssessment(): void {
      this.btnDisabled = true;
      this.supervisionService.saveCaseManagerAssessmentReport(this.buildAssessmentDto()).subscribe(
         response => {
            this.id = response;
            this.btnDisabled = false;
            this.toastr.success('NSP_MOCK.SAVED_DATA');
         },
         error => {
            manageError(this.toastr, ErrorType.SAVE_DATA);
            this.btnDisabled = false;
         }
      );
   }

   private applyDtoToFormGroup(form: FormGroup, dto: Partial<Record<string, CompetencyRowDto>>): void {
      Object.keys(form.controls).forEach(key => {
         const control = form.get(key) as FormGroup;
         const row = dto?.[key];

         // If DTO doesn't have this key, do not overwrite (useful for PATCH / partial DTOs)
         if (!row) return;

         control.patchValue(
            {
               rating: row.rating ?? null,
               comment: row.comment ?? '',
            },
            { emitEvent: false }
         );
      });
   }
   private populateFormsFromDto(dto: CaseManagerAssessmentDto): void {
      // Steps 1-5: competencies
      if (dto == null) {
         return;
      }
      this.applyDtoToFormGroup(this.firstStepForm, dto as any);
      this.applyDtoToFormGroup(this.secondStepForm, dto as any);
      this.applyDtoToFormGroup(this.thirdStepForm, dto as any);
      this.applyDtoToFormGroup(this.fourthStepForm, dto as any);
      this.applyDtoToFormGroup(this.fifthStepForm, dto as any);

      // Step 6: summary fields
      this.sixthStepForm.patchValue(
         {
            caseManagerStrengths: dto.caseManagerStrengths ?? '',
            areasForImprovement: dto.areasForImprovement ?? '',
         },
         { emitEvent: false }
      );

      // Goals (keep your goals array shape consistent with your template)
      this.goals = (dto.goals ?? []).map(g => ({
         goal: g.goal ?? '',
         activity: g.activity ?? '',
         timeframe: g.timeframe ?? null,
         responsiblePerson: g.responsiblePerson ?? '',
      }));

      // Mark pristine so PATCH can later detect user changes cleanly
      this.firstStepForm.markAsPristine();
      this.secondStepForm.markAsPristine();
      this.thirdStepForm.markAsPristine();
      this.fourthStepForm.markAsPristine();
      this.fifthStepForm.markAsPristine();
      this.sixthStepForm.markAsPristine();
      this.id = dto.id;
   }
}
